import React from 'react';
import { Switch as BaseSwitch } from '@material-ui/core';

const Switch = (props) => <BaseSwitch {...props} />;

export default Switch;
